import { HttpClient } from "@angular/common/http"
import { Injectable, inject } from "@angular/core"
import { Observable } from "rxjs"

import { SchoolInvoiceMasterCreateRequestDTO, SchoolInvoiceMasterDTO, SchoolInvoiceMasterUpdateRequestDTO, SchoolInvoiceMasterList, SchoolInvoiceMasterDeleteRequestDTO, SchoolInvoiceMasterReadByIdRequestDTO, SchoolInvoiceMasterReadByMasterIdRequestDTO, SchoolInvoiceMasterReadAllPaginatedRequestDTO } from "./receipt-master.interface"
import { SchoolInvoiceMaster_Create, SchoolInvoiceMaster_Update, SchoolInvoiceMaster_ReadAll, SchoolInvoiceMaster_Delete, SchoolInvoiceMaster_ReadById, SchoolInvoiceMaster_ReadAllPaginated } from "src/app/GlobalVariable"
import { PaginatedDTO } from "src/app/Common/common.interface"

@Injectable({
  providedIn: 'root'
})
export class SchoolInvoiceMasterService {

  constructor() { }
  http = inject(HttpClient)
  SchoolInvoiceMaster_Create(data: SchoolInvoiceMasterCreateRequestDTO): Observable<SchoolInvoiceMasterDTO> {
    return this.http.post<SchoolInvoiceMasterDTO>(SchoolInvoiceMaster_Create, data)
  }

  SchoolInvoiceMaster_Update(data: SchoolInvoiceMasterUpdateRequestDTO): Observable<SchoolInvoiceMasterDTO> {
    return this.http.post<SchoolInvoiceMasterDTO>(SchoolInvoiceMaster_Update, data)
  }

  SchoolInvoiceMaster_ReadAll(): Observable<SchoolInvoiceMasterList> {
    return this.http.get<SchoolInvoiceMasterList>(SchoolInvoiceMaster_ReadAll)
  }
  SchoolInvoiceMaster_Delete(data: SchoolInvoiceMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SchoolInvoiceMaster_Delete, data)
  }


  SchoolInvoiceMaster_ReadById(data: SchoolInvoiceMasterReadByIdRequestDTO): Observable<SchoolInvoiceMasterDTO> {
    return this.http.post<SchoolInvoiceMasterDTO>(SchoolInvoiceMaster_ReadById, data)
  }

  // SchoolInvoiceMaster_ReadByMasterId(data: SchoolInvoiceMasterReadByMasterIdRequestDTO): Observable<SchoolInvoiceMasterList> {
  //   return this.http.post<SchoolInvoiceMasterList>(SchoolInvoiceMaster_ReadByMasterId, data)
  // }

  // SchoolInvoiceMaster_ReadAllPaginated(data: PaginatedDTO): Observable<SchoolInvoiceMasterList> {
  //   return this.http.post<SchoolInvoiceMasterList>(SchoolInvoiceMaster_ReadAllPaginated, data);
  // }

  SchoolInvoiceMaster_ReadAllPaginated(
  data: SchoolInvoiceMasterReadAllPaginatedRequestDTO
): Observable<SchoolInvoiceMasterList> {
  return this.http.post<SchoolInvoiceMasterList>(
    SchoolInvoiceMaster_ReadAllPaginated,
    data
  );
}


}
